<div class="new-dwellings-filter">
    <div class="filter-header">
        <h1>Filter</h1>
        <div class="sub-title">Nybygg</div>
        <div class="right-align">
            <div class="close-filter-button" (click)="onCloseFilter()"></div>
        </div>
    </div>

    <div class="filter-section">
        <new-dwellings-filter-ownership [filterForm]="filterForm.ownershipOptions"></new-dwellings-filter-ownership>
    </div>
    <div class="filter-section">
        <new-dwellings-filter-estate-types [filterForm]="filterForm.dwellingTypes"></new-dwellings-filter-estate-types>
    </div>
    <div class="filter-section">
        <new-dwellings-filter-sale-build-status
            [filterFormSaleStatus]="filterForm.saleStatusOptions"
            [filterFormBuildStatus]="filterForm.buildStatusOptions"
        ></new-dwellings-filter-sale-build-status>
    </div>
    <div class="filter-section">
        <new-dwellings-filter-time-period [filterForm]="filterForm.timePeriod"></new-dwellings-filter-time-period>
    </div>
</div>
